module.exports = __webpack_public_path__ + "img/1920x800.c99fd632.png";